import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";

import { authMiddleware } from "./middleware/middlewares";
import bookingTemplatesSlice from "./slices/bookingTemplateSlice";
import commoditiesSlice from "./slices/commoditySlice";
import companySlice from "./slices/companySlice";
import domesticSlice from "./slices/domesticSlice";
import filterQuoteSlice from "./slices/filterQuoteSlice";
import notificationsSlice from "./slices/notificationsSlice";
import portsSlice from "./slices/portsSlice";
import quoteReasonsSlice from "./slices/quoteReasons";
import quotesSlice from "./slices/quotesSlice";
import registrySlice from "./slices/registrySlice";
import userProfileSlice from "./slices/userProfileSlice";

const loggerMiddleware = createLogger();

const rootReducer = combineReducers({
  filterQuoteSlice,
  quotesSlice,
  quoteReasonsSlice,
  notificationsSlice,
  userProfileSlice,
  registrySlice,
  portsSlice,
  companySlice,
  commoditiesSlice,
  bookingTemplatesSlice,
  domesticSlice,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return process.env.NODE_ENV === "production"
      ? getDefaultMiddleware().concat(authMiddleware)
      : getDefaultMiddleware().concat(loggerMiddleware).concat(authMiddleware);
  },
});
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
